import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {assignProductAccountEntitlementsStateSelector} from './assign-product-account-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ResourceView} from 'src/modules/entitlements/typedef';

export const assignProductAccountEntitlementsDataSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignProductAccountEntitlements');

export const assignProductAccountEntitlementsActions =
    assignProductAccountEntitlementsDataSlice.actions;

export const assignProductAccountEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.accountPage.assignProductEntitlements.result.cache;

export const assignProductAccountEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.accountPage.assignProductEntitlements.result;

export const assignProductAccountEntitlementsResultSelector = getCachedTableResultSelector(
    assignProductAccountEntitlementsCacheSelector,
    assignProductAccountEntitlementsStateSelector,
);
